import axios from "axios";
import Swal from "sweetalert2";
export const siteURL = process.env.REACT_APP_BASE_URL;
export const baseURL = `${process.env.REACT_APP_BASE_URL}/api/v1`;
const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("at")}`,
  },
});

const handleTokenExpiration = async (error) => {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry && localStorage.getItem("rft")!=null) {
    originalRequest._retry = true;
    api.post(`${baseURL}/auth/refreshtoken`, {
      refreshToken: localStorage.getItem("rft"),
    }).then((res)=>{
      if (res.status === 200) {
        console.log(res);
        localStorage.setItem("at", res.data.result.access_token);
        localStorage.setItem("rft", res.data.result.refresh_token);
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.result.access_token}`;
        window.location.reload();
        //return api(originalRequest);
      }
    }).catch((err)=>{
      localStorage.clear();
      window.location.href = "/signin";
    })
    return api(originalRequest);
  }
  return Promise.reject(error);
};

export const refreshAccessToken = async () => {
  const res = await api.post(`${baseURL}/auth/refreshtoken`, {
    refreshToken: localStorage.getItem("rft"),
  });
  if (res.status === 200) {
    localStorage.setItem("at", res.data.result.access_token);
    localStorage.setItem("rft", res.data.result.refresh_token);
    api.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${res.data.result.access_token}`;
  }
};


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      return handleTokenExpiration(error);
    } else {
      return Promise.reject(error);
    }
  }
);

api.interceptors.request.use(function (config) {
  if (localStorage.getItem("at") != null) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("at")}`;
  }
  return config;
});

export const logout = async () => {
  if (
    localStorage.getItem("at") !== null &&
    localStorage.getItem("rft") !== null
  ) {
    api
      .post(`${baseURL}/auth/signout`, {
        refreshToken: localStorage.getItem("rft"),
      })
      .then((res) => {
        console.log(res);
        if (res.data.success) {
          localStorage.removeItem("at");
          localStorage.removeItem("rft");
          Swal.fire("", "Successfully logged out", "success");
        }
      })
      .catch((err) => {
        console.log(err);
        localStorage.removeItem("at");
        localStorage.removeItem("rft");
      });
  }
};

export default api;
